// Auto-generated: real client photos (optimized) served from public/gallery
export const PRODUCTION_GALLERY = [
  "/gallery/produzione/001.jpg",
  "/gallery/produzione/002.jpg",
  "/gallery/produzione/003.jpg",
  "/gallery/produzione/004.jpg",
  "/gallery/produzione/005.jpg",
  "/gallery/produzione/006.jpg",
  "/gallery/produzione/007.jpg",
  "/gallery/produzione/008.jpg",
  "/gallery/produzione/009.jpg",
  "/gallery/produzione/010.jpg",
  "/gallery/produzione/011.jpg",
  "/gallery/produzione/012.jpg",
  "/gallery/produzione/013.jpg",
  "/gallery/produzione/014.jpg",
  "/gallery/produzione/015.jpg",
  "/gallery/produzione/016.jpg",
  "/gallery/produzione/017.jpg",
  "/gallery/produzione/018.jpg",
  "/gallery/produzione/019.jpg",
  "/gallery/produzione/020.jpg",
  "/gallery/produzione/021.jpg",
  "/gallery/produzione/022.jpg",
  "/gallery/produzione/023.jpg",
  "/gallery/produzione/024.jpg",
  "/gallery/produzione/025.jpg",
  "/gallery/produzione/026.jpg",
  "/gallery/produzione/027.jpg",
  "/gallery/produzione/028.jpg",
  "/gallery/produzione/029.jpg",
  "/gallery/produzione/030.jpg",
  "/gallery/produzione/031.jpg",
  "/gallery/produzione/032.jpg",
  "/gallery/produzione/033.jpg",
  "/gallery/produzione/034.jpg",
  "/gallery/produzione/035.jpg",
  "/gallery/produzione/036.jpg",
  "/gallery/produzione/037.jpg",
  "/gallery/produzione/038.jpg",
  "/gallery/produzione/039.jpg",
  "/gallery/produzione/040.jpg",
  "/gallery/produzione/041.jpg",
  "/gallery/produzione/042.jpg",
  "/gallery/produzione/043.jpg",
  "/gallery/produzione/044.jpg",
  "/gallery/produzione/045.jpg",
  "/gallery/produzione/046.jpg",
  "/gallery/produzione/047.jpg",
  "/gallery/produzione/048.jpg",
  "/gallery/produzione/049.jpg",
  "/gallery/produzione/050.jpg",
  "/gallery/produzione/051.jpg",
  "/gallery/produzione/052.jpg",
  "/gallery/produzione/053.jpg",
  "/gallery/produzione/054.jpg",
  "/gallery/produzione/055.jpg",
  "/gallery/produzione/056.jpg",
  "/gallery/produzione/057.jpg",
  "/gallery/produzione/058.jpg",
  "/gallery/produzione/059.jpg",
  "/gallery/produzione/060.jpg",
  "/gallery/produzione/061.jpg",
  "/gallery/produzione/062.jpg",
  "/gallery/produzione/063.jpg",
  "/gallery/produzione/064.jpg",
  "/gallery/produzione/065.jpg",
  "/gallery/produzione/066.jpg",
  "/gallery/produzione/067.jpg",
  "/gallery/produzione/068.jpg",
  "/gallery/produzione/069.jpg",
  "/gallery/produzione/070.jpg",
  "/gallery/produzione/071.jpg",
  "/gallery/produzione/072.jpg",
  "/gallery/produzione/073.jpg",
  "/gallery/produzione/074.jpg",
  "/gallery/produzione/075.jpg",
  "/gallery/produzione/076.jpg",
];

export const PRODUCTS_GALLERY = [
  "/gallery/prodotti/001.jpg",
  "/gallery/prodotti/002.jpg",
  "/gallery/prodotti/003.jpg",
  "/gallery/prodotti/004.jpg",
  "/gallery/prodotti/005.jpg",
  "/gallery/prodotti/006.jpg",
  "/gallery/prodotti/007.jpg",
  "/gallery/prodotti/008.jpg",
  "/gallery/prodotti/009.jpg",
  "/gallery/prodotti/010.jpg",
  "/gallery/prodotti/011.jpg",
  "/gallery/prodotti/012.jpg",
  "/gallery/prodotti/013.jpg",
  "/gallery/prodotti/014.jpg",
  "/gallery/prodotti/015.jpg",
  "/gallery/prodotti/016.jpg",
  "/gallery/prodotti/017.jpg",
  "/gallery/prodotti/018.jpg",
  "/gallery/prodotti/019.jpg",
  "/gallery/prodotti/020.jpg",
  "/gallery/prodotti/021.jpg",
  "/gallery/prodotti/022.jpg",
  "/gallery/prodotti/023.jpg",
  "/gallery/prodotti/024.jpg",
  "/gallery/prodotti/025.jpg",
  "/gallery/prodotti/026.jpg",
  "/gallery/prodotti/027.jpg",
  "/gallery/prodotti/028.jpg",
  "/gallery/prodotti/029.jpg",
  "/gallery/prodotti/030.jpg",
  "/gallery/prodotti/031.jpg",
  "/gallery/prodotti/032.jpg",
  "/gallery/prodotti/033.jpg",
  "/gallery/prodotti/034.jpg",
  "/gallery/prodotti/035.jpg",
  "/gallery/prodotti/036.jpg",
  "/gallery/prodotti/037.jpg",
  "/gallery/prodotti/038.jpg",
  "/gallery/prodotti/039.jpg",
  "/gallery/prodotti/040.jpg",
  "/gallery/prodotti/041.jpg",
  "/gallery/prodotti/042.jpg",
  "/gallery/prodotti/043.jpg",
  "/gallery/prodotti/044.jpg",
  "/gallery/prodotti/045.jpg",
  "/gallery/prodotti/046.jpg",
  "/gallery/prodotti/047.jpg",
  "/gallery/prodotti/048.jpg",
  "/gallery/prodotti/049.jpg",
  "/gallery/prodotti/050.jpg",
  "/gallery/prodotti/051.jpg",
  "/gallery/prodotti/052.jpg",
  "/gallery/prodotti/053.jpg",
  "/gallery/prodotti/054.jpg",
  "/gallery/prodotti/055.jpg",
  "/gallery/prodotti/056.jpg",
  "/gallery/prodotti/057.jpg",
  "/gallery/prodotti/058.jpg",
  "/gallery/prodotti/059.jpg",
  "/gallery/prodotti/060.jpg",
  "/gallery/prodotti/061.jpg",
  "/gallery/prodotti/062.jpg",
  "/gallery/prodotti/063.jpg",
  "/gallery/prodotti/064.jpg",
  "/gallery/prodotti/065.jpg",
  "/gallery/prodotti/066.jpg",
  "/gallery/prodotti/067.jpg",
  "/gallery/prodotti/068.jpg",
  "/gallery/prodotti/069.jpg",
  "/gallery/prodotti/070.jpg",
  "/gallery/prodotti/071.jpg",
  "/gallery/prodotti/072.jpg",
  "/gallery/prodotti/073.jpg",
];

export const DRAWINGS_GALLERY = [
  "/gallery/disegni/001.jpg",
  "/gallery/disegni/002.jpg",
  "/gallery/disegni/003.jpg",
  "/gallery/disegni/004.jpg",
  "/gallery/disegni/005.jpg",
  "/gallery/disegni/006.jpg",
  "/gallery/disegni/007.jpg",
  "/gallery/disegni/008.jpg",
  "/gallery/disegni/009.jpg",
  "/gallery/disegni/010.jpg",
  "/gallery/disegni/011.jpg",
  "/gallery/disegni/012.jpg",
  "/gallery/disegni/013.jpg",
  "/gallery/disegni/014.jpg",
  "/gallery/disegni/015.jpg",
  "/gallery/disegni/016.jpg",
];

